<template>
  <WaggonInfoBody
    :color="getTWorkPackage(tworkpackage_id).color"
    :work_package="getTWorkPackage(tworkpackage_id)"
    :info_box="wallet || $vuetify.breakpoint.smAndDown?false:true"
    :wallet="wallet"
    >
    <template #body-content>
      <StandardFlexBox
        height="34px"
        line_height="30px"
      >
      <div :style="`color:${getTWorkPackage(tworkpackage_id).textcolor}`">{{$t('Project.Workpackage.LogList.Header')}} ({{getTWorkPackageLogList.length}})</div>
      <!-- <v-spacer/> -->
      <StandardOverflowButton
        tooltip="Set Filter"
        class="ml-1"
        icon="filter_list"
        :small="true"
        icon_color="black"
        :multiselect="true"
        :value="{actions: getLogListFilter.actions}"
        :button_color="getLogListFilter.filter? 'grey lighten-4':''"
        button_color_selected="grey lighten-4"
        :options="{actions: [
          {value: 'added', icon: 'add', tooltip: 'added'},
          {value: 'removed', icon: 'remove', tooltip: 'removed'},
          {value: 'updated', icon: 'build', tooltip: 'updated'},
          {value: 'created comment', icon: 'sms', tooltip: 'created comment'},
        ]}"
        @select-option="setLogListFilter({setting: $event.setting, value: $event.value})"
        @button-clicked="setLogListFilter({setting: 'filter'})"
        />
      </StandardFlexBox>
      <StandardFlexBox
        height="calc(100% - 44px)"
        id="logList"
        direction="column"
        :no_wrap="true"
        >
        <StandardDataField
          class="pa-1 mb-1"
          v-for="entry in getTWorkPackageLogList"
          :key="entry.id"
          :header="`${entry.user} ${entry.created.substring(0, 19)}`"
          :value="entry.target === 'comment'?
                  entry.value:
                  `${entry.target} ${entry.action}: ${entry.value}`"
          :icon="getLogListIcon(entry)"
          :readonly="true"
          :append_icon="entry.crossed_out === true?'subtitles':'subtitles_off'"
          width="100%"
          :crossed_out="entry.crossed_out"
          @clickAppendIcon="toggleCrossedOut(entry)"
          />
        <StandardDataField
          v-if="
          hasProjectPermission({
            project_id: project_id,
            ppermission: 'Update Work Packages'
            }) ||
          getOwnTWorkPackages(project_id).includes(tworkpackage_id)
          "
          style="position: sticky; bottom: 5px"
          :key="update_key_add_comment"
          line_height="30px"
          color="grey darken-3"
          text_color="white"
          value=""
          icon="sms"
          append_icon="send"
          placeholder="addcomment"
          width="100%"
          @changeValue="submitLogListComment($event, update_key_add_comment), update_key_add_comment++"
          @keydown.enter.native="submitLogListComment($event, update_key_add_comment), update_key_add_comment++"
          />
      </StandardFlexBox>
    </template>
  </WaggonInfoBody>
</template>
<script>
import store from '@/store/index'

import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js'

export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_id', 'tworkpackage_id', 'wallet'],
  mixins: [
    WaggonInfoMixin
  ],
  beforeRouteEnter(to, from, next) {
    store.dispatch('TWorkPackageLogList/requestTWorkPackageLogList', {
      project_id: to.params.project_id,
      train_id: to.params.train_id,
      taktarea_id: to.params.taktarea_id,
      twaggon_id: to.params.twaggon_id,
      twork_package_id: to.params.tworkpackage_id
    })
    .then(() => {
      next();
    });
  },
  mounted() {
    var element = document.getElementById("logList");
    element.scrollTop = element.scrollHeight;
  },
  watch: {
    getTWorkPackageLogList: function() {
      setTimeout(function () {
        var element = document.getElementById("logList");
        element.scrollTop = element.scrollHeight;
      }, 10);
    },
  },
  methods: {
    submitLogListComment(comment){
      this.createLogListComment({
        project_id: this.project_id,
        train_id: this.train_id,
        taktarea_id: this.taktarea_id,
        twaggon_id: this.twaggon_id,
        twork_package_id: this.tworkpackage_id,
        data: {
          comment: comment,
        }
      });
    }
  }
}
</script>
<style>
  div {
    user-select: none;
  }
</style>
